import { render, staticRenderFns } from "./image-editor.vue?vue&type=template&id=1a6e9f4a&scoped=true"
import script from "./image-editor.vue?vue&type=script&lang=js"
export * from "./image-editor.vue?vue&type=script&lang=js"
import style0 from "./image-editor.vue?vue&type=style&index=0&id=1a6e9f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6e9f4a",
  null
  
)

export default component.exports